import { render, staticRenderFns } from "./walletReport.vue?vue&type=template&id=4708fb62"
import script from "./walletReport.vue?vue&type=script&lang=js"
export * from "./walletReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports